import React from 'react';
import { NavbarBrand } from 'reactstrap';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
    return (
        <footer>
            <div>Powered by</div>
            <NavbarBrand tag={Link} to="/"><img src="/img/logo.png" width="152" height="38" alt="" /></NavbarBrand>
        </footer>
    );
}